/*
 * @Author: duchongchong1
 * @Date: 2022-11-02 16:43:23
 * @LastEditors: wuzhonghai1 wuzhonghai1@jd.com
 * @LastEditTime: 2026-06-08 17:41:30
 * @FilePath: /isp_International/src/api/newApi/header.ts
 * @Description:
 */
import http from '../axios';
import {
  ApiResponse,
  buildRequestCacheKey,
  readTtlCache,
  RequestParams,
  withInflightDedupe,
  writeTtlCache,
} from '@/util/requestDedupe';

const CATEGORY_TREE_CACHE_TTL = 5 * 60 * 1000;
const categoryTreeCache = new Map<string, { expiresAt: number; value: ApiResponse }>();
const categoryTreeInflight = new Map<string, Promise<ApiResponse>>();
/**
 * 类目树缓存版本号：强制刷新时递增，防止旧 inflight 请求返回后污染新缓存。
 */
let categoryTreeCacheVersion = 0;

const isSuccessResponse = (res: unknown): res is ApiResponse =>
  Boolean(res && typeof res === 'object' && (res as { success?: unknown }).success === true);

export  function getLogo()  {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/public/logo', {}, false, true).then(
        res=>{
          resolve(res)
        },
        error => {
          console.log('网络异常~', error);
          reject(error);
        },
    )
  })
}
// 查询 header类目树
export function getTree(params: any) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/category/gettree', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

const requestCategoryTree = (params: RequestParams): Promise<ApiResponse> =>
  new Promise((resolve, reject) => {
    http('get', '/jdig/category/tree', params, false, true).then(
      res => {
        resolve(res as ApiResponse);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });

export function clearCategoryTreeCache() {
  categoryTreeCache.clear();
  categoryTreeInflight.clear();
  categoryTreeCacheVersion += 1;
}

// 查询类目树数据 - CategoryDrawer使用
export function getCategoryTree(params: RequestParams = {}, forceRefresh = false): Promise<ApiResponse> {
  if (forceRefresh) {
    clearCategoryTreeCache();
  }

  const requestVersion = categoryTreeCacheVersion;
  // 清缓存可能和旧请求返回交错；版本号入 key，避免旧 inflight 回写后再次被新请求命中。
  const cacheKey = `${buildRequestCacheKey('/jdig/category/tree', params)}:v${requestVersion}`;
  const cached = !forceRefresh ? readTtlCache(categoryTreeCache, cacheKey) : null;
  if (cached) {
    return Promise.resolve(cached);
  }

  // 类目树是页面初始化高频接口，同参数并发合并；只缓存成功响应，避免失败态被放大。
  return withInflightDedupe(categoryTreeInflight, cacheKey, () =>
    requestCategoryTree(params).then(res => {
      if (requestVersion === categoryTreeCacheVersion && isSuccessResponse(res)) {
        writeTtlCache(categoryTreeCache, cacheKey, res, CATEGORY_TREE_CACHE_TTL);
      }
      return res;
    }),
  );
}
// 本土跨境站点切换接口
export function getChangeStation(params: any) {
  return http('get', '/jdig/public/change/station', params, false, true)
}
// 语言切换接口
export function getChangeEnv(params: { env: string, reqStartTime?:number }) {
  console.log('params', params)
  return new Promise((resolve, reject) => {
    http('get', '/jdig/public/changeEnv', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
//emil
export function sendVerifyMail(params: any) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/account/sendVerifyMail', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
// 获取首页广告配置
export function getAd(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/ad/getAd', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

type AuthorityResponse = Record<string, any>;

let cachedAuthority: AuthorityResponse | null = null;
let inflightAuthority: Promise<AuthorityResponse> | null = null;

function requestAuthority(params: any = {}) {
  return new Promise<AuthorityResponse>((resolve, reject) => {
    http('get', '/jdig/auth/authority', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function clearAuthorityCache() {
  cachedAuthority = null;
  inflightAuthority = null;
}

/** 客户功能权限（物料编码等）：全站复用，同一时刻只发起一次请求 */
export function getAuthority(params: any = {}, forceRefresh = false) {
  if (!forceRefresh && cachedAuthority) {
    return Promise.resolve(cachedAuthority);
  }

  if (!forceRefresh && inflightAuthority) {
    return inflightAuthority;
  }

  inflightAuthority = requestAuthority(params)
    .then(res => {
      cachedAuthority = res;
      return res;
    })
    .catch(error => {
      console.log('网络异常~', error);
      throw error;
    })
    .finally(() => {
      inflightAuthority = null;
    });

  return inflightAuthority;
}

//获取权限功能配置
export function getQuickButtons(params: any = {}) {
  return new Promise((resolve, reject) => {
    http('get', '/jdig/topbar/quick', params, false, true).then(
      res => {
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}

export function getCustomerServiceToken(params: any) {
  return new Promise((resolve, reject) => {
    http('jsonpost', '/jdig/customer/token', params, false, true).then(
      res => {
        // console.log('jdig/cart/getCartNum', res);
        resolve(res);
      },
      error => {
        console.log('网络异常~', error);
        reject(error);
      },
    );
  });
}
